import React, { Component, Fragment } from 'react';
import { Row, Col, Card, CardTitle, CardBody, CardFooter } from 'shards-react';

import './_home.css';

// eslint-disable-next-line react/prefer-stateless-function
class Home extends Component {
  render() {
    const { labSessions, TAs } = this.props;
    return (
      <Fragment>
        <Row>
          <Col sm="12" md={{ size: 10, offset: 1 }}>
            <Card>
              <CardBody>
                <CardTitle>CS 390 VR</CardTitle>
                <div className="video">
                  <iframe
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    frameBorder="0"
                    src="https://www.youtube-nocookie.com/embed/FWvJiiq42j8?controls=0"
                    title="CS390VR Showcase"
                  />
                </div>
              </CardBody>
              <CardFooter>
                CS390VR is a course designed to teach you how to create virtual
                reality experiences using modern game development packages.
                Students will have a choice of Unity or Unreal Engine for each
                project, and have access to the HTC Vive, Oculus Rift DK2, and
                Leap Motion devices for their projects.
              </CardFooter>
            </Card>
          </Col>
          <Col sm="12" md="1" lg="1" />
        </Row>
        <Row>
          <Col sm="12" md="1" lg="1" />
          <Col sm="12" md="10" lg="10">
            <div className="list">
              <h4>Lab Sessions</h4>
              <table className="table">
                <thead>
                  <tr>
                    <th>Day</th>
                    <th>Time</th>
                    <th>Place</th>
                    <th>TAs</th>
                  </tr>
                </thead>
                <tbody>
                  {labSessions.map(session => (
                    <tr>
                      <td>{session.day}</td>
                      <td>{session.time}</td>
                      <td>{session.location}</td>
                      <td>{session.TAs}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md={{ size: 10, offset: 1 }}>
            <div className="list">
              <h4>TAs</h4>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Position</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {TAs.map(TA => (
                    <tr>
                      <td>{TA.name}</td>
                      <td>{TA.position}</td>
                      <td>{TA.email}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md={{ size: 10, offset: 1 }}>
            <div className="list">
              <h4>Office Hours</h4>
              <table>
                <thead>
                  <tr>
                    <th>TA</th>
                    <th>Day</th>
                    <th>Time</th>
                    <th>Location</th>
                  </tr>
                </thead>
                <tbody>
                  {TAs.map(TA => {
                    if (typeof TA.officeHours === 'object') {
                      return TA.officeHours.map(officeHours => {
                        return (
                          <tr>
                            <td>{TA.name}</td>
                            <td>{officeHours.day}</td>
                            <td>{officeHours.time}</td>
                            <td>{officeHours.location}</td>
                          </tr>
                        );
                      });
                    }
                    return null;
                  })}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default Home;
